import React from 'react';
import FilterResultsButton from './FilterResultsButton'
import './filter.css';
const navs = [{ key: 'services', label: 'Services' },
{ key: 'availability', label: 'Availability' },
{ key: 'benefits', label: 'Benefits' }];

const FilterFooter = (props) => {
    let { availableServices, filter } = props.services;
    let count = 0;
    let filteredNavs = navs.filter((nav) => nav.key !== props.selectedKey);
    let isFiltered = true;
    let bottomStyle = '-53px';
    bottomStyle = '0';
    if (!filter || (!filter.selectedGuest && !filter.selectedCategory && !filter.selectedDate && !filter.selectedBenefit)) {
        isFiltered = false;
        bottomStyle = 'auto';
    }
    if (availableServices)
        count = availableServices.length;
    return (
        <div style={{ bottom: bottomStyle }} className={`spa-filter-footer headline-gray-e6-bg gotham-xn-medium ${isFiltered ? 'sticky-footer' : ''}`} >
            <div className='filter-footer-content '>

                <span className='filter-footer-label' data-test-id="filter-by"  >{`Filter by: `}</span>
                {
                    filteredNavs.map((nav) => (
                        <button className='filter-footer-item link-text font-size-p2 gotham-xn-medium title-hover button-link' data-test-id="footer-link" onClick={onTabClick.bind(this, props, nav.key)} >{nav.label}</button>
                    ))
                }
                <span className='filter-button-container padding-10'>
                    <FilterResultsButton isServicesLoading={props.isServicesLoading} onClick={props.onFilterButtonClick} count={count} />
                    {
                        isFiltered &&
                        <span className='d-md-none'>
                            <span className='banner-text filtered-reset font-size-p1 gotham-xn-medium' data-test-id="reset-button" onClick={props.resetFilter}>
                                <svg focusable="false" className="svg-icon svg-icon-refresh"> <use xlinkHref="#icon-refresh" data-test-id="reset-button-undo" ></use></svg> Reset Filters
                        </span>
                        </span>
                    }
                </span>

            </div>

        </div>
    )
}

const onTabClick = (prop, selectedKey) => prop.onTabClick(selectedKey, 'footer');

export default FilterFooter;